import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { Home } from "../screens/Home";
import { SelectionPage } from "../screens/SelectionPage";
import BeforeTreatment from "../screens/BeforeTreatment";
import { DuringTreatment } from "../screens/DuringTreatment";
import AfterTreatment from "../screens/AfterTreatment";
import { InfoPage } from "../screens/InfoPage";
import { PoliticaTermos } from "../screens/PoliticaTermos";

const { Navigator, Screen } = createNativeStackNavigator();

export function AppRoutes() {
  return (
    <Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Screen name="Home" component={Home} />
      <Screen
        name="SelectionPage"
        component={SelectionPage}
        options={{
          headerShown: true,
          headerTitle: "Direitos",
          headerTintColor: "#f4545c",
        }}
      />
      <Screen
        name="BeforeTreatment"
        component={BeforeTreatment}
        options={{
          headerShown: true,
          headerTitle: "Antes do tratamento",
          headerTintColor: "#c8bfb6",
        }}
      />
      <Screen
        name="DuringTreatment"
        component={DuringTreatment}
        options={{
          headerShown: true,
          headerTitle: "Durante o tratamento",
          headerTintColor: "#abb79c",
        }}
      />
      <Screen
        name="AfterTreatment"
        component={AfterTreatment}
        options={{
          headerShown: true,
          headerTitle: "Depois do tratamento",
          headerTintColor: "#b19286",
        }}
      />
      <Screen
        name="InfoPage"
        component={InfoPage}
        options={{
          headerShown: true,
          headerTitle: "Informações",
          headerTintColor: "#f4545c",
        }}
      />
      <Screen
        name="SubInfoPage"
        component={InfoPage}
        options={{
          headerShown: true,
          headerTitle: "Informações",
          headerTintColor: "#f4545c",
        }}
      />
      <Screen
        name="PoliticaTermos"
        component={PoliticaTermos}
        options={{
          headerShown: true,
          headerTitle: "Política e Termos",
          headerTintColor: "#f4545c",
        }}
      />
    </Navigator>
  );
}
